import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import {
  useDataIsSubmitting,
  useDataSubmit,
  useDataChange,
  useDataValue,
} from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'app',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'install' })
  }
}

export function useOnClickCancel(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let change = useDataChange({
    context: 'flow_shortcuts',
    path: 'forceInstall',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(null)
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}

export function useDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'app',
    viewPath: props.viewPath,
  })
  let acceptedTermsAndConditions = useDataValue({
    context: 'app',
    path: 'acceptedTermsAndConditions',
    viewPath: props.viewPath,
  })

  return isSubmitting || !acceptedTermsAndConditions
}
